export default {
  en: {
    continueDefault: 'Continue',
    logOut: 'Log out',
  },
  ru: {
    continueDefault: 'Продолжить',
    logOut: 'Выйти',
  },
  de: {
    continueDefault: 'Weiter',
    logOut: 'Abmelden',
  },
  pt: {
    continueDefault: 'Continuar',
    logOut: 'Sair',
  },
  fr: {
    continueDefault: 'Continuer',
    logOut: 'Se déconnecter',
  },
  es: {
    continueDefault: 'Continuar',
    logOut: 'Cerrar sesión',
  },
};
